import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="htmltemplateelement" id="htmltemplateelement"></a>
    <h1 {...{
      "id": "windowhtmltemplateelement"
    }}>{`window.HTMLTemplateElement`}</h1>
    <p>{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLTemplateElement"
      }}>{`Web APIs - HTMLTemplateElement`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <a name="htmltemplateelement-content" id="htmltemplateelement-content"></a>
    <h2 {...{
      "id": "content--documentfragment"
    }}>{`content : `}<inlineCode parentName="h2">{`DocumentFragment`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Returns a template element's template content. return type is DocumentFragment object.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLTemplateElement/content"
      }}>{`HTMLTemplateElement - content`}</a>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      